export default __webpack_public_path__ + "static/revolutionizing-forklift-9b7b5280f3e8dc73d52fdbe9bb58a46c.png";